/* eslint-disable no-continue */
import Vue from 'vue';
import * as types from './types';
import helper from '@/core/helper';

const mutations = {
  [types.SET_LANGUAGES]: (state, payload) => {
    state.languages.splice(0, state.languages.length, ...payload);
  },
  [types.SET_CONTENT_ITEMS_URLS_CHANGED]: (state, payload) => {
    state.contentItemsUrlsChanged = payload;
  },
  [types.SET_IN_PROGRESS_CONTENT_SCRAPES]: (state, payload) => {
    if (payload.hasOwnProperty('totalStartLength')) {
      state.inProgressContentScrapes.totalStartLength = payload.totalStartLength !== 0 ? payload.totalStartLength : 0;
    }
    Vue.set(state.inProgressContentScrapes, 'contentItems', payload.contentItems ?? []);
  },
  [types.SET_KILL_CURRENT_SCRAPING_FETCH]: (state, payload) => {
    state.killCurrentScrapingFetch = payload;
  },
  [types.NEW_SET_SCRAPED_CONTENT]: (state, payload) => {
    state.newScrapedContent = payload;
  },
  [types.NEW_SET_CONTENT_ITEMS]: (state, payload) => {
    state.newContentItems = payload;
  },
  [types.NEW_SET_CONTENT_ITEMS_DISPLAY_PROPERTIES]: (state, payload) => {
    const displayProperties = {};
    for (let i = 0; i < payload.displayProperties.length; i++) {
      displayProperties[payload.displayProperties[i].contentItemUuid] = payload.displayProperties[i];
    }
    Vue.set(state.contentItemsDisplayProperties, payload.creativeId, displayProperties);
  },
  [types.SET_IMAGE_ASSET_NAMES]: (state, payload) => {
    const imageAssetNames = {};
    const imageFullPaths = payload.filter((imageFullPath) => !imageFullPath.endsWith('/') && imageFullPath.split('/').length === 2);
    imageFullPaths.forEach((imageFullPath) => {
      const imageWithFolders = imageFullPath.split('/');
      const creativeSizeName = imageWithFolders[0];
      const imageName = imageWithFolders[1];
      imageAssetNames[creativeSizeName] = imageAssetNames[creativeSizeName] || [];
      imageAssetNames[creativeSizeName].push(imageName);
    });
    state.imageAssetNames = imageAssetNames;
  },
  [types.REMOVE_IMAGE_ASSET_NAME]: (state, payload) => {
    const { creativeSizeName, imageName } = payload;
    state.imageAssetNames[creativeSizeName] = state.imageAssetNames[creativeSizeName]
      .filter((name) => name !== imageName);
  },
  [types.SET_CONTENT_ITEM_PUBLISHING_STATE]: (state, payload) => {
    const index = state.newContentItems.findIndex((contentItem) => contentItem.id === payload.contentItemId);
    Vue.set(state.newContentItems[index], 'state', payload.state);
  },
  [types.SET_CONTENT_EDITOR_ARTICLE]: (state, payload) => {
    if (helper.objLength(payload) === 0) return Vue.set(state, 'contentEditorArticle', {});
    Vue.set(state.contentEditorArticle, `${payload.property}`, payload.value);
  },
  [types.SET_SELECTED_ARTICLE_UUID]: (state, payload) => {
    state.selectedArticleUuid = payload;
  },
  [types.UPDATE_CONTENT_ITEMS_DISPLAY_PROPERTIES]: (state, payload) => {
    const { contentItemsDisplayProperties, selectedCreativeId } = state;
    if (contentItemsDisplayProperties[selectedCreativeId].hasOwnProperty(`${[payload.contentItemUuid]}`) === false) return;
    Vue.set(contentItemsDisplayProperties[selectedCreativeId], payload.contentItemUuid, { ...payload });
  },
  [types.SET_FILTERS_QUERY]: (state, payload) => {
    state.filtersQuery = payload;
  },
  [types.SET_CONTENT_ITEM_QUERY_PARAM]: (state, payload) => {
    if (helper.objLength(payload) === 0) {
      Vue.set(state, 'contentItemsQueryParams', {});
      return;
    }
    for (const param in payload) {
      if (!payload.hasOwnProperty(param)) continue;
      const value = payload[param];
      if (value) Vue.set(state.contentItemsQueryParams, param, value);
      else if (state.contentItemsQueryParams.hasOwnProperty(`${param}`)) Vue.delete(state.contentItemsQueryParams, param);
    }
  },
  [types.SET_LOADING_ARTICLES]: (state, payload) => {
    state.isLoadingArticles = payload;
  },
  [types.SET_LOADING_ARTICLES_SECTION]: (state, payload) => {
    state.loadingArticlesSection = payload;
  },
  [types.SET_CONTENT_SCRAPE_ID]: (state, payload) => {
    state.scrapingBatchId = payload;
  },
  [types.SET_SCRAPED_CONTENT]: (state, payload) => {
    state.scrapedContent = payload;
  },
  [types.RESET_CONTENT_ITEM]: (state) => {
    state.contentItems = [];
  },
  [types.SET_CONTENT_ITEMS]: (state, payload) => {
    state.contentItems = payload;
  },
  [types.ADD_CONTENT_ITEM]: (state, payload) => {
    const selectedItemIndex = state.contentItems.find((item) => item.id === payload.id);
    if (!selectedItemIndex) {
      state.contentItems.push(payload);
    }
  },
  [types.UPDATE_ITEM]: (state, payload) => {
    const index = Array.from(state.contentItems)
      .findIndex((item) => item.id === payload.id);
    Vue.set(state.contentItems, index, { ...payload });
  },
  [types.SET_CREATIVE_CONTENT_STATES]: (state, payload) => {
    state.creativeContentStates = payload;
  },
  [types.UPDATE_A_CREATIVE_CONTENT_STATE]: (state, payload) => {
    const { creativeContentStates } = state;
    const { creativeId, updatedItem } = payload;
    const updatedCreativeContentIndex = creativeContentStates
      .findIndex((creativeContent) => creativeContent.contentItemUuid === updatedItem.contentItemUuid);
    const target = state.contentItemsDisplayProperties[creativeId][updatedItem.contentItemUuid];
    if (target) Vue.set(target, 'active', updatedItem.active);
    Vue.set(creativeContentStates, updatedCreativeContentIndex, updatedItem);
  },
  [types.UPDATE_DISPLAY_COPY]: (state, { contentItemUuid, displayCopy }) => {
    state.allDisplayCopy = {
      ...state.allDisplayCopy,
      [contentItemUuid]: {
        ...state.allDisplayCopy[contentItemUuid],
        [state.selectedCreativeId]: displayCopy,
      },
    };
  },
  [types.SET_ALL_DISPLAY_COPY]: (state, payload) => {
    state.allDisplayCopy = payload;
  },
  [types.SET_CUSTOM_PROPERTY_TYPES]: (state, payload) => {
    state.customPropertyTypes = payload;
  },
  [types.SET_CREATIVE]: (state, payload) => {
    state.selectedCreativeId = payload.id;
    state.selectedCreativeSizeName = payload.sizeName;
    state.creative = payload;
  },
  [types.SET_CREATIVES]: (state, payload) => {
    state.creatives = payload;
  },
  [types.SET_CREATIVES_SIZES]: (state, payload) => {
    state.creativesSizes = payload;
  },
  [types.SET_ACTIVE_CREATIVES]: (state, payload) => {
    state.activeCreatives = payload;
  },
  [types.UPDATE_CREATIVES_PROPERTIES_BY_ID]: (state, payload) => {
    const { creatives, activeCreatives } = state;
    const updatedCreatives = payload[0];
    const matchingCreative = creatives.find((creative) => creative.id === updatedCreatives.id);
    matchingCreative.properties = updatedCreatives.properties;
    const matchingActiveCreative = activeCreatives.find((creative) => creative.id === updatedCreatives.id);
    matchingActiveCreative.properties = updatedCreatives.properties;
  },
  [types.SET_CREATIVE_TEMPLATES]: (state, payload) => {
    state.creativeTemplates = payload;
  },
  [types.TRIGGER_CREATIVE_RERENDER]: (state, payload) => {
    state.timestamp = payload;
  },
  [types.SET_FEED_ID]: (state, payload) => {
    state.feedId = payload;
  },
  [types.SET_CONTENT_TOTAL_ITEMS]: (state, payload) => {
    state.totalItems = payload;
  },
  [types.SET_CONTENT_TOTAL_PUBLISHED_ITEMS]: (state, payload) => {
    state.totalPublished = payload;
  },
  [types.SET_TOTAL_PAGES]: (state, payload) => {
    state.totalPages = payload;
  },
  [types.SET_PAGE_SIZE]: (state, payload) => {
    state.pageSize = payload;
  },
  [types.SET_CURRENT_PAGE]: (state, payload) => {
    state.page = payload;
  },
  [types.SET_CREATIVE_MODE]: (state, payload) => {
    state.mode = payload;
  },
  [types.SET_COMMENTS_COUNT]: (state, payload) => {
    state.commentsCounts = payload;
  },
  [types.INCREMENT_COMMENTS_COUNT]: (state, payload) => {
    let count = 1;
    if (state.commentsCounts.hasOwnProperty(payload.contentId)) {
      count = state.commentsCounts[payload.contentId].count + 1;
    }
    Vue.set(
      state.commentsCounts,
      payload.contentId,
      { count },
    );
  },
  [types.UPDATE_CURRENT_COMMENTS]: (state, payload) => {
    state.currentComments = payload;
  },
  [types.SET_IS_SELF_SERVICE_CONTENT]: (state, payload) => {
    state.isSelfServiceContent = payload;
  },
  [types.SET_SEARCH_QUERY]: (state, payload) => {
    state.query = payload;
  },
  [types.TOGGLE_ANNOTATIONS]: (state, payload) => {
    state.allowAnnotations = payload;
  },
  [types.TRIGGER_ANNOTATION]: (state, payload) => {
    state.isTriggeredAnnotation = payload;
  },
  [types.SET_IS_SIDEBAR_INPUT_FOCUSED]: (state, payload) => {
    state.isSidebarInputFocused = payload;
  },
  [types.UPDATE_CURRENT_ANNOTATION_STATE]: (state, payload) => {
    state.isAddingNewAnnotation = payload;
  },
  [types.UPDATE_CURRENT_ANNOTATION]: (state, payload) => {
    state.currentAnnotation = payload;
  },
  [types.CLEAR_CURRENT_COMMENTS]: (state) => {
    state.currentComments = [];
  },
  [types.SET_FEED_COUNT]: (state, payload) => {
    state.feedTotalCount = payload;
  },
  [types.SET_SHARED_COUNT]: (state, payload) => {
    state.sharedCount = payload;
  },
  [types.SET_CONTENT_LIST_TYPE]: (state, payload) => {
    state.contentListType = payload;
  },
  [types.SET_EMAIL_USER_ON_SCRAPE_COMPLETION]: (state, payload) => {
    state.emailOnCompletion = payload;
  },
  [types.SET_CREATIVE_BOTTOM_PANEL_IS_OPEN]: (state, payload) => {
    state.creativeBottomPanelIsOpen = payload;
  },
  [types.SET_CREATIVE_SIDEBAR_IS_OPEN]: (state, payload) => {
    state.creativeSidebarIsOpen = payload;
  },
  [types.SET_CONTENT_STATES]: (state, payload) => {
    state.contentStates = payload;
  },
  [types.SET_ADD_UNITS_SELECTED]: (state, payload) => {
    state.adUnitsSelected = payload;
  },
  [types.SET_CREATIVE_TYPE_SELECTED]: (state, payload) => {
    state.creativeTypeSelected = payload;
  },
  [types.CLEAR_CREATIVES]: (state) => {
    state.creatives = [];
    state.activeCreatives = [];
    state.creativeTemplates = [];
  },
};

export default mutations;
